import React, { useState, useRef, useEffect } from "react";
import { Col, Container, Form, Image, Nav, Navbar, NavDropdown, Row } from 'react-bootstrap'
import logo from '../assest/images/logo.svg'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { ApiService } from "../Components/Service/apiservices";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { useCart } from "../Components/Service/CartContext";

function Header({ carthandleShow, isSearchPage }) {
    const { cartItems } = useCart();
    // toggle js start 
    const [sideNavStyle, setSideNavStyle] = useState({ right: "-250px" });
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [mediaImg, setmediaImg] = useState('');
    const [userSession, setUserSession] = useState(null);
    const [isOpen, setIsOpen] = useState(null);

    const closeMenu = () => {
        setIsOpen(null)
    };


    const toggleMenu = () => {
        if (sideNavStyle.right == "-250px") {
            setSideNavStyle({ right: "0" });
            setIsMenuOpen(true); // Menu is open
        } else {
            setSideNavStyle({ right: "-250px" });
            setIsMenuOpen(false); // Menu is closed
        }
    };
    const navRef = useRef(null);

    const handleClick = (event) => {
        if (navRef.current) {
            // Remove "active" class from all nav-links
            navRef.current.querySelectorAll(".nav-link").forEach((link) => {
                link.classList.remove("active");
            });
            // Add "active" class to the clicked link
            event.target.classList.add("active");
        }
    };
    // nav active js end  

    const [menuData, setMenuData] = useState([]);
    const [themeAdmin, setThemeAdmin] = useState([]);
    const [goldData, setGoldData] = useState([]);
    const [logoUrl, setLogoUrl] = useState('');
    const [isLoading, setisLoading] = useState(true)
    const [headerClass, setHeaderClass] = useState('')


    const didMountRef = useRef(true);
    useEffect(() => {
        if (didMountRef.current) {
            setUserSession(localStorage.getItem("USER_TOKEN")); // Set session state
            getCommonData();
            getgoldData();
        }
        didMountRef.current = false;
    }, []);
    const getCommonData = () => {
        ApiService.fetchData("common").then((res) => {
            if (res.status == "success") {

                setMenuData(res.menus);
                setThemeAdmin(res.themesAdmin);
                setLogoUrl(res.logoUrl);
                setmediaImg(res.mediaImg)
                setTimeout(() => {
                    setisLoading(false)
                }, 500)
            }
        }).catch(() => {
        });
    };
    const getgoldData = () => {
  ApiService.fetchData("get-gold-price")
    .then((res) => {
      if (res.status === "success" && res.goldData?.length > 0) {
        const today = new Date().toISOString().split("T")[0]; // Get today's date as "YYYY-MM-DD"

        // Find record that matches today's date
        const todayGold = res.goldData.find(item => item.date === today);

        if (todayGold) {
          setGoldData(todayGold);
        } else {
          // If today's not found, fallback to latest record
          setGoldData(res.goldData[0]);
        }
      }
    })
    .catch((error) => {
      console.error("Error fetching gold data:", error);
    });
};



    // header stikey js start 
    useEffect(() => {
        const defaultHeader = document.querySelector('.default_header');
        const stickyHeader = document.querySelector('.sticky_header');

        const handleScroll = () => {
            const isScrolled = window.scrollY > 50;

            if (isScrolled) {
                defaultHeader.classList.add('header-hidden');
                defaultHeader.classList.remove('header-visible');

                stickyHeader.classList.remove('header-hidden');
                stickyHeader.classList.add('header-visible');
            } else {
                defaultHeader.classList.remove('header-hidden');
                defaultHeader.classList.add('header-visible');

                stickyHeader.classList.add('header-hidden');
                stickyHeader.classList.remove('header-visible');
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const [selectedCurrency, setSelectedCurrency] = useState('rupee');

    const setCurrency = (e) => {
        const value = e.target.value;
        setSelectedCurrency(value);
        localStorage.setItem("currency", value);
        window.location.reload();
    }

    useEffect(() => {
        const savedValue = localStorage.getItem("currency");
        if (savedValue) {
            setSelectedCurrency(savedValue);
        }
    }, []);
    // header stikey js end 


    return (
        <React.Fragment>
            {/* <marquee className="py-2 mb-0 text-warning bg-dark " behavior="scroll" direction="left">
                {goldData?.price_gram_24k ? (
                    <>
                    <span className="mx-2">
                        Gold 24 CT | {selectedCurrency === "₹" ? "₹" : "$"}{" "}
                        {Number(
                        selectedCurrency === "₹"
                            ? goldData.price_gram_24k
                            : goldData.price_gram_24k / 83 // rough USD conversion rate
                        ).toLocaleString("en-IN", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                        })}
                    </span>

                    <span className="mx-2">|</span>

                    <span className="mx-2">
                        Gold 22 CT | {selectedCurrency === "₹" ? "₹" : "$"}{" "}
                        {Number(
                        selectedCurrency === "₹"
                            ? goldData.price_gram_22k
                            : goldData.price_gram_22k / 83
                        ).toLocaleString("en-IN", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                        })}
                    </span>

                    <span className="mx-2">|</span>

                    <span className="mx-2">
                        Gold 20 CT | {selectedCurrency === "₹" ? "₹" : "$"}{" "}
                        {Number(
                        selectedCurrency === "₹"
                            ? goldData.price_gram_20k
                            : goldData.price_gram_20k / 83
                        ).toLocaleString("en-IN", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                        })}
                    </span>

                    <span className="mx-2">|</span>

                    <span className="mx-2">
                        Gold 18 CT | {selectedCurrency === "₹" ? "₹" : "$"}{" "}
                        {Number(
                        selectedCurrency === "₹"
                            ? goldData.price_gram_18k
                            : goldData.price_gram_18k / 83
                        ).toLocaleString("en-IN", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                        })}
                    </span>
                    </>
                ) : (
                    "Fetching today's gold rates..."
                )}
            </marquee> */}


            <header className={isSearchPage ? 'header default_header search_open' : 'header default_header'}>
                <Container fluid >
                    <div className='top_header d-flex align-items-center justify-content-between position-relative'>
                        <div className='top_select'>
                            <select name="currency-select" value={selectedCurrency} onChange={setCurrency} className="currency-select" aria-label="Currency preference:">
                                <option value="₹">Rupee ₹</option>
                                <option value="$">USD $</option>
                            </select>
                        </div>
                       


                        <marquee >
                            <Link to="/trade">
                                {themeAdmin.admin_store_marque}
                            </Link>
                        </marquee>
                        {isLoading ? <>
                            <div className='brand_logo position-absolute'>
                                <Link to="/"><Skeleton width={300} height={61}></Skeleton></Link>
                            </div>
                        </> :
                            <div className='brand_logo position-absolute'>
                                <Link to="/" className="logo_default"><Image src={logoUrl + themeAdmin.admin_store_header_image} /></Link>
                                <Link to="/" className="logo_white d-none"><Image src={logoUrl + themeAdmin.admin_store_white_image} /></Link>
                            </div>
                        }

                        <div className='top_right_link d-flex align-items-center'>
                            <Link to="/search"><i className="fa-solid fa-magnifying-glass"></i></Link>
                            <Link to={userSession ? "/wishList" : "/login"}>
                                <i className="fa-regular fa-heart"></i>
                            </Link>
                            <Link to={userSession ? "/my-account" : "/login"}>
                                <i className="fa-solid fa-user"></i>
                            </Link>
                            <Link to="/cart">
                                <i className="fa-solid fa-cart-shopping"></i>
                                <span>({cartItems})</span> </Link>
                            {/* <Link to="/search"><Image src={search_new} /></Link>
                            <Link to="/login" ><Image src={account_new} /></Link>
                            <Link to="/cart"><Image src={bag_nw} /> <span>({cartItems})</span> </Link> */}
                        </div>
                    </div>
                    <Navbar expand="md" className="p-0">
                        <Container>
                            <Navbar.Toggle aria-controls="basic-navbar-nav" className='border-0 p-0' />
                            <Navbar.Collapse id="basic-navbar-nav ">
                                <Nav className="m-auto" ref={navRef} onClick={handleClick}>
                                    {isLoading ? <>
                                        <Skeleton width={50} key={1}></Skeleton>
                                        <Skeleton width={50} key={2}></Skeleton>
                                        <Skeleton width={50} key={3}></Skeleton>
                                        <Skeleton width={50} key={4}></Skeleton>
                                        <Skeleton width={50} key={5}></Skeleton>
                                        <Skeleton width={50} key={6}></Skeleton>
                                        <Skeleton width={50} key={7}></Skeleton>
                                    </> :
                                        <>
                                            {menuData.map((menu, key) => {
                                                return <div className={`dd ${isOpen === menu.menu_name ? "open" : ""}`} onMouseEnter={() => setIsOpen(menu.menu_name)} onMouseLeave={() => setIsOpen(null)}>
                                                    {menu.link != "#" ? <NavLink key={key} to={menu.link} className={`nav-link position-relative p-0`}>
                                                        {menu.menu_name}
                                                    </NavLink> : <div className="nav-link position-relative p-0">{menu.menu_name}</div>}
                                                    {menu.menu_ismegamenu == 1 ?
                                                        <div className="mega_menu position-absolute">
                                                            <Container>
                                                                <Row>
                                                                    {menu.children.map((children, key1) => {
                                                                        return <Col md={(children?.menu_image != null) ? 3 : 3} key={key1}>
                                                                            <div className="">
                                                                                {(children?.menu_image != null) ? <>
                                                                                    <img src={mediaImg + children.menu_image} alt="" />
                                                                                </> : <>
                                                                                    {(children?.menu_hidetitle == 0) ? <h5>{children.menu_name}</h5> : <></>}
                                                                                    {children.children.length > 0 ?
                                                                                        <ul>
                                                                                            {children.children.map((children2, key2) => {
                                                                                                return <li key={key2}>
                                                                                                    <Link to={children2.link} className="nav-link position-relative" onClick={closeMenu}>{children2.menu_name}</Link>
                                                                                                </li>
                                                                                            })}
                                                                                        </ul>

                                                                                        : <></>
                                                                                    }
                                                                                </>
                                                                                }
                                                                            </div>
                                                                        </Col>
                                                                    })}
                                                                </Row>
                                                            </Container>
                                                        </div>
                                                        : menu.menu_ismegamenu == 0 && menu.children.length > 0 ?
                                                            <div className="drop_down position-absolute">
                                                                <ul>
                                                                    {menu.children.map((children, key1) => {
                                                                        return <li>
                                                                            <Link onClick={closeMenu} key={key1} to={children.link} className="nav-link position-relative">{children.menu_name}</Link>
                                                                        </li>
                                                                    })}

                                                                </ul>
                                                            </div>
                                                            :
                                                            <></>
                                                    }



                                                    {/* <div className="drop_down position-absolute">
                                                        <ul>
                                                            <li>
                                                                <Link to="#" className="nav-link position-relative">B2B Diamond Buying Guide</Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" className="nav-link position-relative">Jewellery Care</Link>
                                                            </li> 
                                                        </ul>
                                                    </div> */}

                                                </div>
                                            })}
                                        </>
                                    }
                                    {/*<NavLink to="/about" className='nav-link position-relative p-0' >About</NavLink>
                                    <NavLink to="/products" className='nav-link position-relative p-0' >Shop</NavLink>
                                    <NavLink to="/collections" className='nav-link position-relative p-0' >Collections</NavLink>
                                    <NavLink to="/estate" className='nav-link position-relative p-0' >Estate</NavLink>
                                    <NavLink to="/bridal" className='nav-link position-relative p-0' >Bridal</NavLink>
                                    <NavLink to="/bespoke" className='nav-link position-relative p-0' >Bespoke</NavLink>
                                    <NavLink to="/contact" className='nav-link position-relative p-0' >Contact</NavLink>
                                    */}
                                </Nav>
                            </Navbar.Collapse>
                        </Container>
                    </Navbar>
                </Container>
            </header>
            <header className={isSearchPage ? 'header sticky_header search_open header-hidden' : 'header sticky_header header-hidden'}>
                <Container fluid >
                    <div className='top_header d-flex align-items-center justify-content-center position-relative'>


                        {isLoading ? <>
                            <div className='brand_logo'>
                                <Link to="/"><Skeleton width={300} height={61}></Skeleton></Link>
                            </div>
                        </> :
                            <div className='brand_logo'>
                                <Link to="/" className="logo_default"><Image src={logoUrl + themeAdmin.admin_store_header_image} /></Link>
                                <Link to="/" className="logo_white d-none"><Image src={logoUrl + themeAdmin.admin_store_white_image} /></Link>
                            </div>
                        }
                        <Navbar expand="md" className="p-0">
                            <Container>
                                <Navbar.Toggle aria-controls="basic-navbar-nav" className='border-0 p-0' />
                                <Navbar.Collapse id="basic-navbar-nav ">
                                    <Nav className="m-auto" ref={navRef} onClick={handleClick}>
                                        {isLoading ? <>
                                            <Skeleton width={50} key={1}></Skeleton>
                                            <Skeleton width={50} key={2}></Skeleton>
                                            <Skeleton width={50} key={3}></Skeleton>
                                            <Skeleton width={50} key={4}></Skeleton>
                                            <Skeleton width={50} key={5}></Skeleton>
                                            <Skeleton width={50} key={6}></Skeleton>
                                            <Skeleton width={50} key={7}></Skeleton>
                                        </> :
                                            <>
                                                {menuData.map((menu, key) => {
                                                    return <div className={`dd ${isOpen === menu.menu_name ? "open" : ""}`} onMouseEnter={() => setIsOpen(menu.menu_name)} onMouseLeave={() => setIsOpen(null)}>
                                                        {menu.link != "#" ? <NavLink key={key} to={menu.link} className={`nav-link position-relative p-0`}>
                                                            {menu.menu_name}
                                                        </NavLink> : <div className="nav-link position-relative p-0">{menu.menu_name}</div>}
                                                        {/* <div className="dd">
                                                         <NavLink key={key} to={menu.link} className='nav-link position-relative p-0 ' >
                                                            {menu.menu_name}
                                                       </NavLink>  */}

                                                        {menu.menu_ismegamenu == 1 ?
                                                            <div className="mega_menu position-absolute">
                                                                <Container>
                                                                    <Row>
                                                                        {menu.children.map((children, key1) => {
                                                                            return <Col md={(children?.menu_image != null) ? 3 : 3} key={key1}>
                                                                                <div className="">
                                                                                    {(children?.menu_image != null) ? <>
                                                                                        <img src={mediaImg + children.menu_image} alt="" />
                                                                                    </> : <>
                                                                                        {(children?.menu_hidetitle == 0) ? <h5>{children.menu_name}</h5> : <></>}
                                                                                        {children.children.length > 0 ?
                                                                                            <ul>
                                                                                                {children.children.map((children2, key2) => {
                                                                                                    return <li key={key2}>
                                                                                                        <Link to={children2.link} className="nav-link position-relative">{children2.menu_name}</Link>
                                                                                                    </li>
                                                                                                })}
                                                                                            </ul>

                                                                                            : <></>
                                                                                        }
                                                                                    </>
                                                                                    }
                                                                                </div>
                                                                            </Col>
                                                                        })}
                                                                    </Row>
                                                                </Container>
                                                            </div>
                                                            : menu.menu_ismegamenu == 0 && menu.children.length > 0 ?
                                                                <div className="drop_down position-absolute">
                                                                    <ul>
                                                                        {menu.children.map((children, key1) => {
                                                                            return <li>
                                                                                <Link key={key1} to={children.link} className="nav-link position-relative">{children.menu_name}</Link>
                                                                            </li>
                                                                        })}

                                                                    </ul>
                                                                </div>
                                                                :
                                                                <></>
                                                        }



                                                        {/* <div className="drop_down position-absolute">
                                                        <ul>
                                                            <li>
                                                                <Link to="#" className="nav-link position-relative">B2B Diamond Buying Guide</Link>
                                                            </li>
                                                            <li>
                                                                <Link to="#" className="nav-link position-relative">Jewellery Care</Link>
                                                            </li> 
                                                        </ul>
                                                    </div> */}

                                                    </div>
                                                })}
                                            </>
                                        }
                                        {/*<NavLink to="/about" className='nav-link position-relative p-0' >About</NavLink>
                                    <NavLink to="/products" className='nav-link position-relative p-0' >Shop</NavLink>
                                    <NavLink to="/collections" className='nav-link position-relative p-0' >Collections</NavLink>
                                    <NavLink to="/estate" className='nav-link position-relative p-0' >Estate</NavLink>
                                    <NavLink to="/bridal" className='nav-link position-relative p-0' >Bridal</NavLink>
                                    <NavLink to="/bespoke" className='nav-link position-relative p-0' >Bespoke</NavLink>
                                    <NavLink to="/contact" className='nav-link position-relative p-0' >Contact</NavLink>
                                    */}
                                    </Nav>
                                </Navbar.Collapse>
                            </Container>
                        </Navbar>

                        <div className='top_select'>
                            <select name="currency-select" value={selectedCurrency} onChange={setCurrency} className="currency-select" aria-label="Currency preference:">
                                <option value="$">USD $</option>
                                <option value="₹">Rupee ₹</option>
                            </select>
                        </div>
                        <div className='top_right_link d-flex align-items-center'>
                            <Link to="/search"><i className="fa-solid fa-magnifying-glass"></i></Link>
                            <Link to={userSession ? "/wishList" : "/login"}>
                                <i className="fa-regular fa-heart"></i>
                            </Link>
                            <Link to={userSession ? "/my-account" : "/login"}><i className="fa-solid fa-user"></i></Link>
                            <Link to="/cart"><i className="fa-solid fa-cart-shopping"></i> <span>({cartItems})</span> </Link>
                            {/* <Link to="/search"><Image src={search_new} /></Link>
                            <Link to="/login" ><Image src={account_new} /></Link>
                            <Link to="/cart"><Image src={bag_nw} /> <span>({cartItems})</span> </Link> */}
                        </div>
                    </div>
                </Container>
            </header>

            <header className={isSearchPage ? 'header_2 d-none position-relative search_open' : 'header_2 d-none position-relative'}>
                <div className='top_header d-flex align-items-center justify-content-between position-relative'>
                    <div className='top_select d-flex align-items-center'>
                        <div id="sideNav" style={sideNavStyle} >
                            <nav>
                                {isLoading ? <>
                                    <Skeleton width={50} key={1}></Skeleton>
                                    <Skeleton width={50} key={2}></Skeleton>
                                    <Skeleton width={50} key={3}></Skeleton>
                                    <Skeleton width={50} key={4}></Skeleton>
                                    <Skeleton width={50} key={5}></Skeleton>
                                    <Skeleton width={50} key={6}></Skeleton>
                                    <Skeleton width={50} key={7}></Skeleton>
                                </> :
                                    <>
                                        {/* {menuData.map((menu, key) => {
                                            return <>
                                                <NavLink key={key} to={menu.link} className='nav-link position-relative p-0' >{menu.menu_name}</NavLink>
                                            </>
                                        })} */}

                                        {menuData.map((menu, key) => (
                                            <div
                                                key={key}
                                                className={`nav-item position-relative ${menu.children && menu.children.length > 0 ? 'dropdown' : ''}`}
                                            >
                                                <NavLink
                                                    to={menu.link}
                                                    className={`nav-link p-0 ${menu.children && menu.children.length > 0 ? 'dropdown-toggle' : ''}`}
                                                    {...(menu.children && menu.children.length > 0
                                                        ? { role: "button", 'data-bs-toggle': "dropdown", 'aria-expanded': "false" }
                                                        : {})}
                                                >
                                                    {menu.menu_hidetitle !== 1 && menu.menu_name}
                                                </NavLink>

                                                {menu.children && menu.children.length > 0 && (
                                                    <div className="dropdown-menu">
                                                        <ul>
                                                            {menu.children.map((child, key1) => (
                                                                <li key={key1}>
                                                                    {child.link !== "#" ? (
                                                                        <NavLink to={child.link} className="nav-link position-relative">
                                                                            {child.menu_hidetitle !== 1 && child.menu_name}
                                                                        </NavLink>
                                                                    ) : (
                                                                        <div className="nav-link position-relative">
                                                                            {child.menu_hidetitle !== 1 && child.menu_name}
                                                                        </div>
                                                                    )}

                                                                    {child.children && child.children.length > 0 && (
                                                                        <ul>
                                                                            {child.children.map((child2, key2) => (
                                                                                <li key={key2}>
                                                                                    <NavLink to={child2.link} className="nav-link position-relative">
                                                                                        {child2.menu_hidetitle !== 1 && child2.menu_name}
                                                                                    </NavLink>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    )}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                        ))}


                                    </>
                                }
                            </nav>
                        </div>

                        <div id="menuBtn" className="me-2" onClick={toggleMenu}>
                            {/* List Icon */}
                            <i className={`bi bi-list `}></i>
                            {/* Close Icon */}
                            <i className={`bi bi-x-lg ${isMenuOpen ? "d-block" : "d-none"}`}></i>
                        </div>
                        <select name="currency-select" className="currency-select" aria-label="Currency preference:">
                            <option value="usd">USD $</option>
                            <option value="rupee">Rupee ₹</option>
                        </select>
                    </div>
                    <div className='brand_logo position-absolute'>
                        <Link to="/"><Image src={logoUrl + themeAdmin.admin_store_header_image} /></Link>
                    </div>
                    <div className='top_right_link d-flex align-items-center'>
                        {/* <Link to="/search"><i className="fa-solid fa-magnifying-glass"></i></Link>
                        <Link to="/login" ><i className="fa-solid fa-user"></i></Link>
                        <Link to="/cart"><i className="fa-solid fa-cart-shopping"></i> <span>({cartItems})</span> </Link>
 */}

                        <Link to={userSession ? "/my-account" : "/login"}><i className="fa-solid fa-user"></i></Link>
                        <Link to={userSession ? "/wishList" : "/login"}>
                            <i className="fa-regular fa-heart"></i>
                        </Link>
                        <Link to="/search" > <i className="fa-solid fa-magnifying-glass"></i> </Link>
                        <Link to="/cart" className='position-relative' onClick={carthandleShow}>
                            <i className="fa-solid fa-cart-shopping"></i>
                            <span>(0)</span>
                        </Link>
                    </div>
                </div>
            </header>
        </React.Fragment>
    )
}

export default Header